export default {
  loading: false,
  errors: [],
}
